<script>
  import _ from 'underscore'
  import ItemPage from '../components/ItemPage.vue'
  import ItemList from '../components/ItemList.vue'
  import PageChooser from '../components/PageChooser.vue'
  import Status from '../components/Status.vue'
  import { item, externalItem } from '../components/Item.vue'
  import Promo2020 from './Promo2020.vue'

  /** @typedef {import('../components/Item.vue').ItemInfo} ItemInfo */


  /**
   * プロモ2020のアイテム情報を流用する
   * @param {string} id アイテムID
   * @return {ItemInfo} アイテム情報
   * @see {externalItem}
   */
  function promo2020Item (id = '') {
    const { items } = Promo2020.data()
    return externalItem(items, id, { collection: 'PT01' })
  }

  export default {
    components: { ItemPage, ItemList, PageChooser, Status },

    data () {
      return {
        date : '2021-06-19',
        major: [
          'PT01',
        ],
        excepts: [
        ],
        items: [

          // [NOTE] WR
          // ================================================================================

          item({
            collection  : 'PT01',
            id          : 'PT1-99',
            rare        : 'WR',
            name        : 'ダンスパンサーまりあワンピ',
            imgUrl      : '/images/items/PT1-99.png',
            kind        : 'ワンピース',
            color       : '桃',
            brand       : 'CH|DS',
            type        : 'LO|CO',
            point       : 2000,
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT01',
            id          : 'PT1-100',
            rare        : 'WR',
            name        : 'ダンスパンサーまりあシューズ',
            imgUrl      : '/images/items/PT1-100.png',
            kind        : 'シューズ',
            color       : '紫',
            brand       : 'CH|DS',
            type        : 'LO|CO',
            point       : 1000,
            numOwned    : { kira: 2 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT01',
            id          : 'PT1-101',
            rare        : 'WR',
            name        : 'ダンスパンサーまりあヘアアクセ',
            imgUrl      : '/images/items/PT1-101.png',
            kind        : 'ヘアアクセ',
            color       : '紫',
            brand       : 'CH|DS',
            type        : 'LO|CO',
            point       : 1000,
            numOwned    : { kira: 2 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT01',
            rare        : 'WR',
          }),


          item({
            collection  : 'PT01',
            id          : 'PT1-102',
            rare        : 'WR',
            name        : 'はあと♡パールすずワンピ',
            imgUrl      : '/images/items/PT1-102.png',
            kind        : 'ワンピース',
            color       : '水',
            brand       : 'CH|DS',
            type        : 'LO|CO',
            point       : 2000,
            numOwned    : { kira: 2 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT01',
            id          : 'PT1-103',
            rare        : 'WR',
            name        : 'はあと♡パールすずシューズ',
            imgUrl      : '/images/items/PT1-103.png',
            kind        : 'シューズ',
            color       : '水',
            brand       : 'CH|DS',
            type        : 'LO|CO',
            point       : 1000,
            numOwned    : { kira: 4 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT01',
            id          : 'PT1-104',
            rare        : 'WR',
            name        : 'はあと♡パールすずヘアアクセ',
            imgUrl      : '/images/items/PT1-104.png',
            kind        : 'ヘアアクセ',
            color       : '黒',
            brand       : 'CH|DS',
            type        : 'LO|CO',
            point       : 1000,
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT01',
            rare        : 'WR',
          }),


          // [NOTE] IR
          // ================================================================================

          item({
            collection  : 'PT01',
            id          : 'IR01-01',
            rare        : 'IR',
            name        : 'レインボースカイイルミナージュみらいドレス',
            imgUrl      : '/images/items/IR01-01.png',
            kind        : 'ワンピース',
            color       : '桃',
            brand       : 'SH',
            type        : 'LO',
            point       : 1600,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT01',
            id          : 'IR01-02',
            rare        : 'IR',
            name        : 'レインボースカイイルミナージュみらいシューズ',
            imgUrl      : '/images/items/IR01-02.png',
            kind        : 'シューズ',
            color       : '桃',
            brand       : 'SH',
            type        : 'LO',
            point       : 800,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT01',
            id          : 'IR01-03',
            rare        : 'IR',
            name        : 'レインボースカイイルミナージュみらいヘアアクセ',
            imgUrl      : '/images/items/IR01-03.png',
            kind        : 'ヘアアクセ',
            color       : '桃',
            brand       : 'SH',
            type        : 'LO',
            point       : 800,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT01',
          }),


          item({
            collection  : 'PT01',
            id          : 'IR01-04',
            rare        : 'IR',
            name        : 'レインボースカイイルミナージュえもドレス',
            imgUrl      : '/images/items/IR01-04.png',
            kind        : 'ワンピース',
            color       : '水',
            brand       : 'GY',
            type        : 'PO',
            point       : 1600,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT01',
            id          : 'IR01-05',
            rare        : 'IR',
            name        : 'レインボースカイイルミナージュえもシューズ',
            imgUrl      : '/images/items/IR01-05.png',
            kind        : 'シューズ',
            color       : '水',
            brand       : 'GY',
            type        : 'PO',
            point       : 800,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT01',
            id          : 'IR01-06',
            rare        : 'IR',
            name        : 'レインボースカイイルミナージュえもヘアアクセ',
            imgUrl      : '/images/items/IR01-06.png',
            kind        : 'ヘアアクセ',
            color       : '水',
            brand       : 'GY',
            type        : 'PO',
            point       : 800,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT01',
          }),


          item({
            collection  : 'PT01',
            id          : 'IR01-07',
            rare        : 'IR',
            name        : 'レインボースカイイルミナージュりんかドレス',
            imgUrl      : '/images/items/IR01-07.png',
            kind        : 'ワンピース',
            color       : '紫',
            brand       : 'SA',
            type        : 'CO',
            point       : 1600,
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT01',
            id          : 'IR01-08',
            rare        : 'IR',
            name        : 'レインボースカイイルミナージュりんかシューズ',
            imgUrl      : '/images/items/IR01-08.png',
            kind        : 'シューズ',
            color       : '紫',
            brand       : 'SA',
            type        : 'CO',
            point       : 800,
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT01',
            id          : 'IR01-09',
            rare        : 'IR',
            name        : 'レインボースカイイルミナージュりんかヘアアクセ',
            imgUrl      : '/images/items/IR01-09.png',
            kind        : 'ヘアアクセ',
            color       : '紫',
            brand       : 'SA',
            type        : 'CO',
            point       : 800,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT01',
          }),


          // [NOTE] ER
          // ================================================================================

          item({
            collection  : 'PT01',
            id          : 'ER1-01',
            rare        : 'ER',
            name        : 'クラシックスイートハニーワンピ',
            imgUrl      : '/images/items/ER1-01.png',
            kind        : 'ワンピース',
            color       : '黒',
            brand       : 'SH',
            type        : 'LO',
            point       : 2000,
            numOwned    : { kira: 2 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT01',
            id          : 'ER1-02',
            rare        : 'ER',
            name        : 'クラシックスイートハニーシューズ',
            imgUrl      : '/images/items/ER1-02.png',
            kind        : 'シューズ',
            color       : '黒',
            brand       : 'SH',
            type        : 'LO',
            point       : 950,
            numOwned    : { kira: 4 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT01',
            id          : 'ER1-03',
            rare        : 'ER',
            name        : 'クラシックスイートハニーヘアアクセ',
            imgUrl      : '/images/items/ER1-03.png',
            kind        : 'ヘアアクセ',
            color       : '黒',
            brand       : 'SH',
            type        : 'LO',
            point       : 950,
            numOwned    : { kira: 6 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT01',
            rare        : 'ER',
          }),


          item({
            collection  : 'PT01',
            id          : 'ER1-04',
            rare        : 'ER',
            name        : 'クラシックガールズエールワンピ',
            imgUrl      : '/images/items/ER1-04.png',
            kind        : 'ワンピース',
            color       : '黒',
            brand       : 'GY',
            type        : 'PO',
            point       : 2000,
            numOwned    : { kira: 3 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT01',
            id          : 'ER1-05',
            rare        : 'ER',
            name        : 'クラシックガールズエールシューズ',
            imgUrl      : '/images/items/ER1-05.png',
            kind        : 'シューズ',
            color       : '黒',
            brand       : 'GY',
            type        : 'PO',
            point       : 950,
            numOwned    : { kira: 3 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT01',
            id          : 'ER1-06',
            rare        : 'ER',
            name        : 'クラシックガールズエールヘアアクセ',
            imgUrl      : '/images/items/ER1-06.png',
            kind        : 'ヘアアクセ',
            color       : '白',
            brand       : 'GY',
            type        : 'PO',
            point       : 950,
            numOwned    : { kira: 3 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT01',
            rare        : 'ER',
          }),


          item({
            collection  : 'PT01',
            id          : 'ER1-07',
            rare        : 'ER',
            name        : 'キラッとチェックシークレットアリスワンピ',
            imgUrl      : '/images/items/ER1-07.png',
            kind        : 'ワンピース',
            color       : '青',
            brand       : 'SA',
            type        : 'CO',
            point       : 2000,
            numOwned    : { kira: 3 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT01',
            id          : 'ER1-08',
            rare        : 'ER',
            name        : 'キラッとチェックシークレットアリスシューズ',
            imgUrl      : '/images/items/ER1-08.png',
            kind        : 'シューズ',
            color       : '赤',
            brand       : 'SA',
            type        : 'CO',
            point       : 950,
            numOwned    : { kira: 5 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT01',
            id          : 'ER1-09',
            rare        : 'ER',
            name        : 'キラッとチェックシークレットアリスヘアアクセ',
            imgUrl      : '/images/items/ER1-09.png',
            kind        : 'ヘアアクセ',
            color       : '白',
            brand       : 'SA',
            type        : 'CO',
            point       : 950,
            numOwned    : { kira: 3 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT01',
            rare        : 'ER',
          }),


          item({
            collection  : 'PT01',
            id          : 'ER1-10',
            rare        : 'ER',
            name        : 'キラッとチェックミラクル☆キラッツワンピ',
            imgUrl      : '/images/items/ER1-10.png',
            kind        : 'ワンピース',
            color       : '赤',
            brand       : 'SH',
            type        : 'LO',
            point       : 2000,
            numOwned    : { kira: 6 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT01',
            id          : 'ER1-11',
            rare        : 'ER',
            name        : 'キラッとチェックミラクル☆キラッツシューズ',
            imgUrl      : '/images/items/ER1-11.png',
            kind        : 'シューズ',
            color       : '赤',
            brand       : 'SH',
            type        : 'LO',
            point       : 950,
            numOwned    : { kira: 3 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT01',
            id          : 'ER1-12',
            rare        : 'ER',
            name        : 'キラッとチェックミラクル☆キラッツヘアアクセ',
            imgUrl      : '/images/items/ER1-12.png',
            kind        : 'ヘアアクセ',
            color       : '赤',
            brand       : 'SH',
            type        : 'LO',
            point       : 950,
            numOwned    : { kira: 3 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT01',
            rare        : 'ER',
          }),


          // [NOTE] FR
          // ================================================================================

          item({
            collection  : 'PT01',
            id          : 'PT1-01',
            rare        : 'FR',
            name        : 'プリ☆ファンナイトトップス',
            imgUrl      : '/images/items/PT1-01.png',
            kind        : 'トップス',
            color       : '青',
            brand       : 'SH',
            type        : 'LO',
            point       : 1100,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT01',
            id          : 'PT1-02',
            rare        : 'FR',
            name        : 'プリ☆ファンナイトスカート',
            imgUrl      : '/images/items/PT1-02.png',
            kind        : 'ボトムス',
            color       : '青',
            brand       : 'SH',
            type        : 'LO',
            point       : 1050,
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT01',
            id          : 'PT1-03',
            rare        : 'FR',
            name        : 'プリ☆ファンナイトシューズ',
            imgUrl      : '/images/items/PT1-03.png',
            kind        : 'シューズ',
            color       : '青',
            brand       : 'SH',
            type        : 'LO',
            point       : 950,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT01',
            id          : 'PT1-04',
            rare        : 'FR',
            name        : 'プリ☆ファンナイトヘアアクセ',
            imgUrl      : '/images/items/PT1-04.png',
            kind        : 'ヘアアクセ',
            color       : '銀',
            brand       : 'SH',
            type        : 'LO',
            point       : 950,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'PT01',
            id          : 'PT1-05',
            rare        : 'FR',
            name        : 'プリ☆ファンおうさまトップス',
            imgUrl      : '/images/items/PT1-05.png',
            kind        : 'トップス',
            color       : '赤',
            brand       : 'PM',
            type        : 'PR',
            point       : 1100,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT01',
            id          : 'PT1-06',
            rare        : 'FR',
            name        : 'プリ☆ファンおうさまパンツ',
            imgUrl      : '/images/items/PT1-06.png',
            kind        : 'ボトムス',
            color       : '赤',
            brand       : 'PM',
            type        : 'PR',
            point       : 1050,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT01',
            id          : 'PT1-07',
            rare        : 'FR',
            name        : 'プリ☆ファンおうさまシューズ',
            imgUrl      : '/images/items/PT1-07.png',
            kind        : 'シューズ',
            color       : '赤',
            brand       : 'PM',
            type        : 'PR',
            point       : 950,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT01',
            id          : 'PT1-08',
            rare        : 'FR',
            name        : 'プリ☆ファンおうさまヘアアクセ',
            imgUrl      : '/images/items/PT1-08.png',
            kind        : 'ヘアアクセ',
            color       : '赤',
            brand       : 'PM',
            type        : 'PR',
            point       : 950,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          // [NOTE] PR
          // ================================================================================

          item({
            collection  : 'PT01',
            id          : 'PT1-09',
            rare        : 'PR',
            name        : 'ハッピーバルーンイエロートップス',
            imgUrl      : '/images/items/PT1-09.png',
            kind        : 'トップス',
            color       : '黄',
            brand       : 'SH',
            type        : 'LO',
            point       : 900,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT01',
            id          : 'PT1-10',
            rare        : 'PR',
            name        : 'ハッピーバルーンイエロースカート',
            imgUrl      : '/images/items/PT1-10.png',
            kind        : 'ボトムス',
            color       : '黄',
            brand       : 'SH',
            type        : 'LO',
            point       : 800,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT01',
            id          : 'PT1-11',
            rare        : 'PR',
            name        : 'ハッピーバルーンイエローシューズ',
            imgUrl      : '/images/items/PT1-11.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : 'SH',
            type        : 'LO',
            point       : 850,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT01',
            id          : 'PT1-12',
            rare        : 'PR',
            name        : 'ハッピーバルーンイエローヘアアクセ',
            imgUrl      : '/images/items/PT1-12.png',
            kind        : 'ヘアアクセ',
            color       : '黄',
            brand       : 'SH',
            type        : 'LO',
            point       : 800,
            numOwned    : { usual: 6 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'PT01',
            id          : 'PT1-13',
            rare        : 'PR',
            name        : 'ハッピーバルーンパープルトップス',
            imgUrl      : '/images/items/PT1-13.png',
            kind        : 'トップス',
            color       : '紫',
            brand       : 'SH',
            type        : 'LO',
            point       : 800,
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT01',
            id          : 'PT1-14',
            rare        : 'PR',
            name        : 'ハッピーバルーンパープルスカート',
            imgUrl      : '/images/items/PT1-14.png',
            kind        : 'ボトムス',
            color       : '紫',
            brand       : 'SH',
            type        : 'LO',
            point       : 850,
            numOwned    : { usual: 6 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT01',
            id          : 'PT1-15',
            rare        : 'PR',
            name        : 'ハッピーバルーンパープルシューズ',
            imgUrl      : '/images/items/PT1-15.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : 'SH',
            type        : 'LO',
            point       : 900,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT01',
            id          : 'PT1-16',
            rare        : 'PR',
            name        : 'ハッピーバルーンパープルヘアアクセ',
            imgUrl      : '/images/items/PT1-16.png',
            kind        : 'ヘアアクセ',
            color       : '紫',
            brand       : 'SH',
            type        : 'LO',
            point       : 800,
            numOwned    : { usual: 6 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'PT01',
            id          : 'PT1-17',
            rare        : 'PR',
            name        : 'マスコットキラッCHUトップス',
            imgUrl      : '/images/items/PT1-17.png',
            kind        : 'トップス',
            color       : '桃',
            brand       : 'LP',
            type        : 'LO',
            point       : 900,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT01',
            id          : 'PT1-18',
            rare        : 'PR',
            name        : 'マスコットキラッCHUスカート',
            imgUrl      : '/images/items/PT1-18.png',
            kind        : 'ボトムス',
            color       : '黄',
            brand       : 'LP',
            type        : 'LO',
            point       : 850,
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT01',
            id          : 'PT1-19',
            rare        : 'PR',
            name        : 'マスコットキラッCHUシューズ',
            imgUrl      : '/images/items/PT1-19.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : 'LP',
            type        : 'LO',
            point       : 800,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT01',
            id          : 'PT1-20',
            rare        : 'PR',
            name        : 'マスコットキラッCHUヘアアクセ',
            imgUrl      : '/images/items/PT1-20.png',
            kind        : 'ヘアアクセ',
            color       : '水',
            brand       : 'LP',
            type        : 'LO',
            point       : 800,
            numOwned    : { usual: 6 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'PT01',
            id          : 'PT1-21',
            rare        : 'PR',
            name        : 'クイーンオブハートトップス',
            imgUrl      : '/images/items/PT1-21.png',
            kind        : 'トップス',
            color       : '赤',
            brand       : 'SA',
            type        : 'CO',
            point       : 850,
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT01',
            id          : 'PT1-22',
            rare        : 'PR',
            name        : 'クイーンオブハートスカート',
            imgUrl      : '/images/items/PT1-22.png',
            kind        : 'ボトムス',
            color       : '赤',
            brand       : 'SA',
            type        : 'CO',
            point       : 900,
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT01',
            id          : 'PT1-23',
            rare        : 'PR',
            name        : 'クイーンオブハートシューズ',
            imgUrl      : '/images/items/PT1-23.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : 'SA',
            type        : 'CO',
            point       : 800,
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT01',
            id          : 'PT1-24',
            rare        : 'PR',
            name        : 'クイーンオブハートヘアアクセ',
            imgUrl      : '/images/items/PT1-24.png',
            kind        : 'ヘアアクセ',
            color       : '赤',
            brand       : 'SA',
            type        : 'CO',
            point       : 800,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          // [NOTE] PR モーリーファンタジー限定
          // ================================================================================

          // [NOTE] SR
          // ================================================================================

          item({
            collection  : 'PT01',
            id          : 'PT1-25',
            rare        : 'SR',
            name        : 'フラワーイースターパープルトップス',
            imgUrl      : '/images/items/PT1-25.png',
            kind        : 'トップス',
            color       : '紫',
            brand       : 'DW',
            type        : 'LO',
            point       : 750,
            numOwned    : { usual: 6 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT01',
            id          : 'PT1-26',
            rare        : 'SR',
            name        : 'フラワーイースターパープルスカート',
            imgUrl      : '/images/items/PT1-26.png',
            kind        : 'ボトムス',
            color       : '紫',
            brand       : 'DW',
            type        : 'LO',
            point       : 700,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT01',
            id          : 'PT1-27',
            rare        : 'SR',
            name        : 'フラワーイースターパープルシューズ',
            imgUrl      : '/images/items/PT1-27.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : 'DW',
            type        : 'LO',
            point       : 650,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT01',
            id          : 'PT1-28',
            rare        : 'SR',
            name        : 'フラワーイースターパープルヘアアクセ',
            imgUrl      : '/images/items/PT1-28.png',
            kind        : 'ヘアアクセ',
            color       : '紫',
            brand       : 'DW',
            type        : 'LO',
            point       : 650,
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'PT01',
            id          : 'PT1-29',
            rare        : 'SR',
            name        : 'アイドルキャストラブリートップス',
            imgUrl      : '/images/items/PT1-29.png',
            kind        : 'トップス',
            color       : '水',
            brand       : 'LP',
            type        : 'LO',
            point       : 750,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT01',
            id          : 'PT1-30',
            rare        : 'SR',
            name        : 'アイドルキャストラブリースカート',
            imgUrl      : '/images/items/PT1-30.png',
            kind        : 'ボトムス',
            color       : '水',
            brand       : 'LP',
            type        : 'LO',
            point       : 700,
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT01',
            id          : 'PT1-31',
            rare        : 'SR',
            name        : 'アイドルキャストラブリーシューズ',
            imgUrl      : '/images/items/PT1-31.png',
            kind        : 'シューズ',
            color       : '水',
            brand       : 'LP',
            type        : 'LO',
            point       : 650,
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT01',
            id          : 'PT1-32',
            rare        : 'SR',
            name        : 'アイドルキャストラブリーヘアアクセ',
            imgUrl      : '/images/items/PT1-32.png',
            kind        : 'ヘアアクセ',
            color       : '水',
            brand       : 'LP',
            type        : 'LO',
            point       : 650,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'PT01',
            id          : 'PT1-33',
            rare        : 'SR',
            name        : 'チェッカーポリストップス',
            imgUrl      : '/images/items/PT1-33.png',
            kind        : 'トップス',
            color       : '青',
            brand       : 'RB',
            type        : 'CO',
            point       : 750,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT01',
            id          : 'PT1-34',
            rare        : 'SR',
            name        : 'チェッカーポリススカート',
            imgUrl      : '/images/items/PT1-34.png',
            kind        : 'ボトムス',
            color       : '青',
            brand       : 'RB',
            type        : 'CO',
            point       : 700,
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT01',
            id          : 'PT1-35',
            rare        : 'SR',
            name        : 'チェッカーポリスシューズ',
            imgUrl      : '/images/items/PT1-35.png',
            kind        : 'シューズ',
            color       : '青',
            brand       : 'RB',
            type        : 'CO',
            point       : 650,
            numOwned    : { usual: 6 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT01',
            id          : 'PT1-36',
            rare        : 'SR',
            name        : 'チェッカーポリスヘアアクセ',
            imgUrl      : '/images/items/PT1-36.png',
            kind        : 'ヘアアクセ',
            color       : '黒',
            brand       : 'RB',
            type        : 'CO',
            point       : 650,
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'PT01',
            id          : 'PT1-37',
            rare        : 'SR',
            name        : 'アンティークリボントップス',
            imgUrl      : '/images/items/PT1-37.png',
            kind        : 'トップス',
            color       : '茶',
            brand       : 'SA',
            type        : 'CO',
            point       : 750,
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT01',
            id          : 'PT1-38',
            rare        : 'SR',
            name        : 'アンティークリボンスカート',
            imgUrl      : '/images/items/PT1-38.png',
            kind        : 'ボトムス',
            color       : '茶',
            brand       : 'SA',
            type        : 'CO',
            point       : 700,
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT01',
            id          : 'PT1-39',
            rare        : 'SR',
            name        : 'アンティークリボンシューズ',
            imgUrl      : '/images/items/PT1-39.png',
            kind        : 'シューズ',
            color       : '茶',
            brand       : 'SA',
            type        : 'CO',
            point       : 650,
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT01',
            id          : 'PT1-40',
            rare        : 'SR',
            name        : 'アンティークリボンヘアアクセ',
            imgUrl      : '/images/items/PT1-40.png',
            kind        : 'ヘアアクセ',
            color       : '茶',
            brand       : 'SA',
            type        : 'CO',
            point       : 650,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'PT01',
            id          : 'PT1-41',
            rare        : 'SR',
            name        : 'アーガイルハートワンピ',
            imgUrl      : '/images/items/PT1-41.png',
            kind        : 'ワンピース',
            color       : '緑',
            brand       : 'CH',
            type        : 'LO',
            point       : 1300,
            numOwned    : { usual: 6 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT01',
            id          : 'PT1-42',
            rare        : 'SR',
            name        : 'アーガイルハートシューズ',
            imgUrl      : '/images/items/PT1-42.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : 'CH',
            type        : 'LO',
            point       : 650,
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT01',
            id          : 'PT1-43',
            rare        : 'SR',
            name        : 'アーガイルハートヘアアクセ',
            imgUrl      : '/images/items/PT1-43.png',
            kind        : 'ヘアアクセ',
            color       : '緑',
            brand       : 'CH',
            type        : 'LO',
            point       : 650,
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT01',
            rare        : 'SR',
          }),


          promo2020Item('AM-534'),
          promo2020Item('AM-535'),
          item({
            collection  : 'PT01',
            id          : 'PT1-44',
            rare        : 'SR',
            name        : 'ファンシーレースアップブルーシューズ',
            imgUrl      : '/images/items/PT1-44.png',
            kind        : 'シューズ',
            color       : '水',
            brand       : 'SH',
            type        : 'LO',
            point       : 650,
            numOwned    : { usual: 6 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT01',
            id          : 'PT1-45',
            rare        : 'SR',
            name        : 'ファンシーレースアップブルーヘアアクセ',
            imgUrl      : '/images/items/PT1-45.png',
            kind        : 'ヘアアクセ',
            color       : '水',
            brand       : 'SH',
            type        : 'LO',
            point       : 650,
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          // [NOTE] R
          // ================================================================================

          item({
            collection  : 'PT01',
            id          : 'PT1-47',
            rare        : 'R',
            name        : 'プリ☆チャンランドキャストピンクトップス',
            imgUrl      : '/images/items/PT1-47.png',
            kind        : 'トップス',
            color       : '桃',
            brand       : 'LP',
            type        : 'LO',
            point       : 600,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT01',
            id          : 'PT1-48',
            rare        : 'R',
            name        : 'プリ☆チャンランドキャストピンクスカート',
            imgUrl      : '/images/items/PT1-48.png',
            kind        : 'ボトムス',
            color       : '桃',
            brand       : 'LP',
            type        : 'LO',
            point       : 550,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT01',
            id          : 'PT1-49',
            rare        : 'R',
            name        : 'プリ☆チャンランドキャストピンクシューズ',
            imgUrl      : '/images/items/PT1-49.png',
            kind        : 'シューズ',
            color       : '桃',
            brand       : 'LP',
            type        : 'LO',
            point       : 500,
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT01',
            id          : 'PT1-50',
            rare        : 'R',
            name        : 'プリ☆チャンランドキャストピンクヘアアクセ',
            imgUrl      : '/images/items/PT1-50.png',
            kind        : 'ヘアアクセ',
            color       : '桃',
            brand       : 'LP',
            type        : 'LO',
            point       : 500,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'PT01',
            id          : 'PT1-54',
            rare        : 'R',
            name        : 'フレアリボンかたみせワンピ',
            imgUrl      : '/images/items/PT1-54.png',
            kind        : 'ワンピース',
            color       : '白',
            brand       : 'SH',
            type        : 'LO',
            point       : 1000,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT01',
            id          : 'PT1-55',
            rare        : 'R',
            name        : 'フレアリボンパンプス',
            imgUrl      : '/images/items/PT1-55.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : 'SH',
            type        : 'LO',
            point       : 500,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT01',
            id          : 'PT1-56',
            rare        : 'R',
            name        : 'フレアリボンぱっちんピン',
            imgUrl      : '/images/items/PT1-56.png',
            kind        : 'ヘアアクセ',
            color       : '水',
            brand       : 'SH',
            type        : 'LO',
            point       : 500,
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT01',
            rare        : 'R',
          }),


          item({
            collection  : 'PT01',
            id          : 'PT1-57',
            rare        : 'R',
            name        : 'ポップエールワンピ',
            imgUrl      : '/images/items/PT1-57.png',
            kind        : 'ワンピース',
            color       : '橙',
            brand       : 'GY',
            type        : 'PO',
            point       : 1000,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT01',
            id          : 'PT1-58',
            rare        : 'R',
            name        : 'ポップエールシューズ',
            imgUrl      : '/images/items/PT1-58.png',
            kind        : 'シューズ',
            color       : '黄',
            brand       : 'GY',
            type        : 'PO',
            point       : 500,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT01',
            id          : 'PT1-59',
            rare        : 'R',
            name        : 'ポップエールヘアアクセ',
            imgUrl      : '/images/items/PT1-59.png',
            kind        : 'ヘアアクセ',
            color       : '水',
            brand       : 'GY',
            type        : 'PO',
            point       : 500,
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT01',
            rare        : 'R',
          }),


          item({
            collection  : 'PT01',
            id          : 'PT1-60',
            rare        : 'R',
            name        : 'ビビッドダンストップス',
            imgUrl      : '/images/items/PT1-60.png',
            kind        : 'トップス',
            color       : '黒',
            brand       : 'DS',
            type        : 'CO',
            point       : 600,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT01',
            id          : 'PT1-61',
            rare        : 'R',
            name        : 'ビビッドダンススカート',
            imgUrl      : '/images/items/PT1-61.png',
            kind        : 'ボトムス',
            color       : '白',
            brand       : 'DS',
            type        : 'CO',
            point       : 550,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT01',
            id          : 'PT1-62',
            rare        : 'R',
            name        : 'ビビッドダンスシューズ',
            imgUrl      : '/images/items/PT1-62.png',
            kind        : 'シューズ',
            color       : '緑',
            brand       : 'DS',
            type        : 'CO',
            point       : 500,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT01',
            id          : 'PT1-63',
            rare        : 'R',
            name        : 'ビビッドダンスヘアアクセ',
            imgUrl      : '/images/items/PT1-63.png',
            kind        : 'ヘアアクセ',
            color       : '黒',
            brand       : 'DS',
            type        : 'CO',
            point       : 500,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'PT01',
            id          : 'PT1-64',
            rare        : 'R',
            name        : 'ギャラクシートップス',
            imgUrl      : '/images/items/PT1-64.png',
            kind        : 'トップス',
            color       : '銀',
            brand       : 'UQ',
            type        : 'CO',
            point       : 600,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT01',
            id          : 'PT1-65',
            rare        : 'R',
            name        : 'ギャラクシースカート',
            imgUrl      : '/images/items/PT1-65.png',
            kind        : 'ボトムス',
            color       : '銀',
            brand       : 'UQ',
            type        : 'CO',
            point       : 550,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT01',
            id          : 'PT1-66',
            rare        : 'R',
            name        : 'ギャラクシーシューズ',
            imgUrl      : '/images/items/PT1-66.png',
            kind        : 'シューズ',
            color       : '黒',
            brand       : 'UQ',
            type        : 'CO',
            point       : 500,
            numOwned    : { usual: 6 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT01',
            id          : 'PT1-67',
            rare        : 'R',
            name        : 'ギャラクシーヘアアクセ',
            imgUrl      : '/images/items/PT1-67.png',
            kind        : 'ヘアアクセ',
            color       : '黒',
            brand       : 'UQ',
            type        : 'CO',
            point       : 500,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'PT01',
            id          : 'PT1-68',
            rare        : 'R',
            name        : 'ミスティムーントップス',
            imgUrl      : '/images/items/PT1-68.png',
            kind        : 'トップス',
            color       : '緑',
            brand       : 'PM',
            type        : 'PR',
            point       : 600,
            numOwned    : { usual: 6 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT01',
            id          : 'PT1-69',
            rare        : 'R',
            name        : 'ミスティムーンスカート',
            imgUrl      : '/images/items/PT1-69.png',
            kind        : 'ボトムス',
            color       : '緑',
            brand       : 'PM',
            type        : 'PR',
            point       : 550,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT01',
            id          : 'PT1-70',
            rare        : 'R',
            name        : 'ミスティムーンシューズ',
            imgUrl      : '/images/items/PT1-70.png',
            kind        : 'シューズ',
            color       : '金',
            brand       : 'PM',
            type        : 'PR',
            point       : 500,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT01',
            id          : 'PT1-71',
            rare        : 'R',
            name        : 'ミスティムーンヘアアクセ',
            imgUrl      : '/images/items/PT1-71.png',
            kind        : 'ヘアアクセ',
            color       : '金',
            brand       : 'PM',
            type        : 'PR',
            point       : 500,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'PT01',
            id          : 'PT1-72',
            rare        : 'R',
            name        : 'アーバンスタイルトップス',
            imgUrl      : '/images/items/PT1-72.png',
            kind        : 'トップス',
            color       : '赤',
            brand       : 'RB',
            type        : 'CO',
            point       : 600,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT01',
            id          : 'PT1-73',
            rare        : 'R',
            name        : 'アーバンスタイルパンツ',
            imgUrl      : '/images/items/PT1-73.png',
            kind        : 'ボトムス',
            color       : '紫',
            brand       : 'RB',
            type        : 'CO',
            point       : 550,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT01',
            id          : 'PT1-74',
            rare        : 'R',
            name        : 'アーバンスタイルシューズ',
            imgUrl      : '/images/items/PT1-74.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : 'RB',
            type        : 'CO',
            point       : 500,
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT01',
            id          : 'PT1-75',
            rare        : 'R',
            name        : 'アーバンスタイルヘアアクセ',
            imgUrl      : '/images/items/PT1-75.png',
            kind        : 'ヘアアクセ',
            color       : '白',
            brand       : 'RB',
            type        : 'CO',
            point       : 500,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'PT01',
            id          : 'PT1-76',
            rare        : 'R',
            name        : 'エレガントパーティーレッドトップス',
            imgUrl      : '/images/items/PT1-76.png',
            kind        : 'トップス',
            color       : '白',
            brand       : 'PM',
            type        : 'PR',
            point       : 600,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT01',
            id          : 'PT1-77',
            rare        : 'R',
            name        : 'エレガントパーティーレッドスカート',
            imgUrl      : '/images/items/PT1-77.png',
            kind        : 'ボトムス',
            color       : '赤',
            brand       : 'PM',
            type        : 'PR',
            point       : 550,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT01',
            id          : 'PT1-78',
            rare        : 'R',
            name        : 'エレガントパーティーレッドシューズ',
            imgUrl      : '/images/items/PT1-78.png',
            kind        : 'シューズ',
            color       : '赤',
            brand       : 'PM',
            type        : 'PR',
            point       : 500,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT01',
            id          : 'PT1-79',
            rare        : 'R',
            name        : 'エレガントパーティーレッドヘアアクセ',
            imgUrl      : '/images/items/PT1-79.png',
            kind        : 'ヘアアクセ',
            color       : '白',
            brand       : 'PM',
            type        : 'PR',
            point       : 500,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          // [NOTE] N
          // ================================================================================

          item({
            collection  : 'PT01',
            id          : 'PT1-80',
            rare        : 'N',
            name        : 'メロディーブルーブラウス',
            imgUrl      : '/images/items/PT1-80.png',
            kind        : 'トップス',
            color       : '水',
            brand       : 'DW',
            type        : 'LO',
            point       : 450,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT01',
            id          : 'PT1-81',
            rare        : 'N',
            name        : 'メロディーブルースカート',
            imgUrl      : '/images/items/PT1-81.png',
            kind        : 'ボトムス',
            color       : '水',
            brand       : 'DW',
            type        : 'LO',
            point       : 400,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT01',
            id          : 'PT1-82',
            rare        : 'N',
            name        : 'メロディーブルーシューズ',
            imgUrl      : '/images/items/PT1-82.png',
            kind        : 'シューズ',
            color       : '水',
            brand       : 'DW',
            type        : 'LO',
            point       : 350,
            numOwned    : { usual: 6 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT01',
            id          : 'PT1-83',
            rare        : 'N',
            name        : 'メロディーブルーヘアアクセ',
            imgUrl      : '/images/items/PT1-83.png',
            kind        : 'ヘアアクセ',
            color       : '水',
            brand       : 'DW',
            type        : 'LO',
            point       : 350,
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'PT01',
            id          : 'PT1-84',
            rare        : 'N',
            name        : 'スターウォッチングトップス',
            imgUrl      : '/images/items/PT1-84.png',
            kind        : 'トップス',
            color       : '桃',
            brand       : 'UQ',
            type        : 'CO',
            point       : 450,
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT01',
            id          : 'PT1-85',
            rare        : 'N',
            name        : 'スターウォッチングスカート',
            imgUrl      : '/images/items/PT1-85.png',
            kind        : 'ボトムス',
            color       : '青',
            brand       : 'UQ',
            type        : 'CO',
            point       : 400,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT01',
            id          : 'PT1-86',
            rare        : 'N',
            name        : 'スターウォッチングシューズ',
            imgUrl      : '/images/items/PT1-86.png',
            kind        : 'シューズ',
            color       : '桃',
            brand       : 'UQ',
            type        : 'CO',
            point       : 350,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT01',
            id          : 'PT1-87',
            rare        : 'N',
            name        : 'スターウォッチングヘアアクセ',
            imgUrl      : '/images/items/PT1-87.png',
            kind        : 'ヘアアクセ',
            color       : '青',
            brand       : 'UQ',
            type        : 'CO',
            point       : 350,
            numOwned    : { usual: 6 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'PT01',
            id          : 'PT1-88',
            rare        : 'N',
            name        : 'ペールブルーワンピ',
            imgUrl      : '/images/items/PT1-88.png',
            kind        : 'ワンピース',
            color       : '水',
            brand       : 'SA',
            type        : 'CO',
            point       : 700,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT01',
            id          : 'PT1-89',
            rare        : 'N',
            name        : 'ペールブルーシューズ',
            imgUrl      : '/images/items/PT1-89.png',
            kind        : 'シューズ',
            color       : '水',
            brand       : 'SA',
            type        : 'CO',
            point       : 350,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT01',
            id          : 'PT1-90',
            rare        : 'N',
            name        : 'ペールブルーヘアアクセ',
            imgUrl      : '/images/items/PT1-90.png',
            kind        : 'ヘアアクセ',
            color       : '水',
            brand       : 'SA',
            type        : 'CO',
            point       : 350,
            numOwned    : { usual: 6 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT01',
            rare        : 'N',
          }),


          item({
            collection  : 'PT01',
            id          : 'PT1-91',
            rare        : 'N',
            name        : 'サマーフローラルナチュラルブラウス',
            imgUrl      : '/images/items/PT1-91.png',
            kind        : 'トップス',
            color       : '緑',
            brand       : 'CH',
            type        : 'LO',
            point       : 450,
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT01',
            id          : 'PT1-92',
            rare        : 'N',
            name        : 'サマーフローラルナチュラルプリーツスカート',
            imgUrl      : '/images/items/PT1-92.png',
            kind        : 'ボトムス',
            color       : '黄',
            brand       : 'CH',
            type        : 'LO',
            point       : 400,
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT01',
            id          : 'PT1-93',
            rare        : 'N',
            name        : 'サマーフローラルナチュラルパンプス',
            imgUrl      : '/images/items/PT1-93.png',
            kind        : 'シューズ',
            color       : '緑',
            brand       : 'CH',
            type        : 'LO',
            point       : 350,
            numOwned    : { usual: 6 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT01',
            id          : 'PT1-94',
            rare        : 'N',
            name        : 'サマーフローラルナチュラルヘアアクセ',
            imgUrl      : '/images/items/PT1-94.png',
            kind        : 'ヘアアクセ',
            color       : '橙',
            brand       : 'CH',
            type        : 'LO',
            point       : 350,
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'PT01',
            id          : 'PT1-95',
            rare        : 'N',
            name        : 'ワイルドスターブルートップス',
            imgUrl      : '/images/items/PT1-95.png',
            kind        : 'トップス',
            color       : '青',
            brand       : 'DS',
            type        : 'CO',
            point       : 450,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT01',
            id          : 'PT1-96',
            rare        : 'N',
            name        : 'ワイルドスターブルースカート',
            imgUrl      : '/images/items/PT1-96.png',
            kind        : 'ボトムス',
            color       : '白',
            brand       : 'DS',
            type        : 'CO',
            point       : 400,
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT01',
            id          : 'PT1-97',
            rare        : 'N',
            name        : 'ワイルドスターブルーサンダル',
            imgUrl      : '/images/items/PT1-97.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : 'DS',
            type        : 'CO',
            point       : 350,
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT01',
            id          : 'PT1-98',
            rare        : 'N',
            name        : 'ワイルドスターブルーヘアアクセ',
            imgUrl      : '/images/items/PT1-98.png',
            kind        : 'ヘアアクセ',
            color       : '銀',
            brand       : 'DS',
            type        : 'CO',
            point       : 350,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          // [NOTE] パシャッとアイテム
          // ================================================================================

          item({
            collection  : 'PT01',
            id          : 'PT1-46',
            rare        : 'SR',
            name        : 'ゆうえんちバルーン',
            imgUrl      : '/images/items/PT1-46.png',
            kind        : 'パシャッとアイテム',
            color       : '黄',
            brand       : 'SH',
            type        : 'LO',
            point       : 650,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT01',
            id          : 'PT1-51',
            rare        : 'R',
            name        : 'チョコショートケーキ',
            imgUrl      : '/images/items/PT1-51.png',
            kind        : 'パシャッとアイテム',
            color       : '茶',
            brand       : 'SH',
            type        : 'LO',
            point       : 500,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT01',
            id          : 'PT1-52',
            rare        : 'R',
            name        : 'ブルークリームソーダ',
            imgUrl      : '/images/items/PT1-52.png',
            kind        : 'パシャッとアイテム',
            color       : '水',
            brand       : 'GY',
            type        : 'PO',
            point       : 500,
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT01',
            id          : 'PT1-53',
            rare        : 'R',
            name        : 'ちゃお',
            imgUrl      : '/images/items/PT1-53.png',
            kind        : 'パシャッとアイテム',
            color       : '桃',
            brand       : '',
            type        : 'PR',
            point       : 500,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          // [NOTE] コーデプリたまチケット
          // ================================================================================

          item({
            collection  : 'コーデプリたまチケット',
            id          : 'PT1-47-SR',
            rare        : 'SR',
            name        : 'プリ☆チャンランドキャストピンクトップス',
            imgUrl      : '/images/items/PT1-47.png',
            kind        : 'トップス',
            color       : '桃',
            brand       : 'LP',
            type        : 'LO',
            point       : 750,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'コーデプリたまチケット',
            id          : 'PT1-48-SR',
            rare        : 'SR',
            name        : 'プリ☆チャンランドキャストピンクスカート',
            imgUrl      : '/images/items/PT1-48.png',
            kind        : 'ボトムス',
            color       : '桃',
            brand       : 'LP',
            type        : 'LO',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'コーデプリたまチケット',
            id          : 'PT1-49-SR',
            rare        : 'SR',
            name        : 'プリ☆チャンランドキャストピンクシューズ',
            imgUrl      : '/images/items/PT1-49.png',
            kind        : 'シューズ',
            color       : '桃',
            brand       : 'LP',
            type        : 'LO',
            point       : 650,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'コーデプリたまチケット',
            id          : 'PT1-50-SR',
            rare        : 'SR',
            name        : 'プリ☆チャンランドキャストピンクヘアアクセ',
            imgUrl      : '/images/items/PT1-50.png',
            kind        : 'ヘアアクセ',
            color       : '桃',
            brand       : 'LP',
            type        : 'LO',
            point       : 650,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          // [NOTE] プレゼントボックス
          // ================================================================================

          item({
            collection  : 'プレゼントボックス',
            id          : 'PB-64',
            rare        : 'SR',
            name        : 'ワンダーランドマカロンワンピ',
            imgUrl      : '/images/items/PB-64.png',
            kind        : 'ワンピース',
            color       : '桃',
            brand       : '',
            type        : 'LO',
            point       : 1300,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プレゼントボックス',
            id          : 'PB-65',
            rare        : 'SR',
            name        : 'ワンダーランドシューズ',
            imgUrl      : '/images/items/PB-65.png',
            kind        : 'シューズ',
            color       : '水',
            brand       : '',
            type        : 'LO',
            point       : 650,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プレゼントボックス',
            id          : 'PB-66',
            rare        : 'SR',
            name        : 'ワンダーランドマカロンヘアアクセ',
            imgUrl      : '/images/items/PB-66.png',
            kind        : 'ヘアアクセ',
            color       : '黄',
            brand       : '',
            type        : 'LO',
            point       : 650,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プレゼントボックス',
          }),


          item({
            collection  : 'プレゼントボックス',
            id          : 'PB-67',
            rare        : 'SR',
            name        : 'リトルローズあでやかトップス',
            imgUrl      : '/images/items/PB-67.png',
            kind        : 'トップス',
            color       : '紫',
            brand       : '',
            type        : 'LO',
            point       : 750,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プレゼントボックス',
            id          : 'PB-68',
            rare        : 'SR',
            name        : 'リトルローズあでやかスカート',
            imgUrl      : '/images/items/PB-68.png',
            kind        : 'ボトムス',
            color       : '紫',
            brand       : '',
            type        : 'LO',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プレゼントボックス',
            id          : 'PB-69',
            rare        : 'SR',
            name        : 'リトルローズあでやかシューズ',
            imgUrl      : '/images/items/PB-69.png',
            kind        : 'シューズ',
            color       : '紫',
            brand       : '',
            type        : 'LO',
            point       : 650,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プレゼントボックス',
            id          : 'PB-70',
            rare        : 'SR',
            name        : 'リトルローズあでやかヘアアクセ',
            imgUrl      : '/images/items/PB-70.png',
            kind        : 'ヘアアクセ',
            color       : '紫',
            brand       : '',
            type        : 'LO',
            point       : 650,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'プレゼントボックス',
            id          : 'PB-71',
            rare        : 'R',
            name        : '男プリマイク',
            imgUrl      : '/images/items/PB-71.png',
            kind        : 'パシャッとアイテム',
            color       : '黒',
            brand       : '',
            type        : 'LO',
            point       : 500,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プレゼントボックス',
          }),
          item({
            collection  : 'プレゼントボックス',
          }),
          item({
            collection  : 'プレゼントボックス',
          }),


          // [NOTE] イースターチャンネル
          // ================================================================================

          item({
            collection  : 'イースターチャンネル',
            id          : 'PT1-105',
            rare        : 'SR',
            name        : 'フラワーイースターピンクトップス',
            imgUrl      : '/images/items/PT1-105.png',
            kind        : 'トップス',
            color       : '桃',
            brand       : 'DW',
            type        : 'LO',
            point       : 750,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'イースターチャンネル',
            id          : 'PT1-106',
            rare        : 'SR',
            name        : 'フラワーイースターピンクスカート',
            imgUrl      : '/images/items/PT1-106.png',
            kind        : 'ボトムス',
            color       : '桃',
            brand       : 'DW',
            type        : 'LO',
            point       : 700,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'イースターチャンネル',
            id          : 'PT1-107',
            rare        : 'SR',
            name        : 'フラワーイースターピンクシューズ',
            imgUrl      : '/images/items/PT1-107.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : 'DW',
            type        : 'LO',
            point       : 650,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'イースターチャンネル',
            id          : 'PT1-108',
            rare        : 'SR',
            name        : 'フラワーイースターピンクヘアアクセ',
            imgUrl      : '/images/items/PT1-108.png',
            kind        : 'ヘアアクセ',
            color       : '桃',
            brand       : 'DW',
            type        : 'LO',
            point       : 650,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'イースターチャンネル',
            id          : 'PT1-109',
            rare        : 'SR',
            name        : 'フラワーイースターブルートップス',
            imgUrl      : '/images/items/PT1-109.png',
            kind        : 'トップス',
            color       : '青',
            brand       : 'DW',
            type        : 'LO',
            point       : 750,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'イースターチャンネル',
            id          : 'PT1-110',
            rare        : 'SR',
            name        : 'フラワーイースターブルースカート',
            imgUrl      : '/images/items/PT1-110.png',
            kind        : 'ボトムス',
            color       : '青',
            brand       : 'DW',
            type        : 'LO',
            point       : 700,
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'イースターチャンネル',
            id          : 'PT1-111',
            rare        : 'SR',
            name        : 'フラワーイースターブルーシューズ',
            imgUrl      : '/images/items/PT1-111.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : 'DW',
            type        : 'LO',
            point       : 650,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'イースターチャンネル',
            id          : 'PT1-112',
            rare        : 'SR',
            name        : 'フラワーイースターブルーヘアアクセ',
            imgUrl      : '/images/items/PT1-112.png',
            kind        : 'ヘアアクセ',
            color       : '青',
            brand       : 'DW',
            type        : 'LO',
            point       : 650,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          // [NOTE] プリティーオールフレンズチャンネル
          // ================================================================================

          item({
            collection  : 'プリティーオールフレンズチャンネル',
            id          : 'PT1-113',
            rare        : 'SR',
            name        : 'オールフレンズそらみらぁらワンピ',
            imgUrl      : '/images/items/PT1-113.png',
            kind        : 'ワンピース',
            color       : '桃',
            brand       : '',
            type        : 'LO',
            point       : 1300,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリティーオールフレンズチャンネル',
            id          : 'PT1-114',
            rare        : 'SR',
            name        : 'オールフレンズそらみらぁらシューズ',
            imgUrl      : '/images/items/PT1-114.png',
            kind        : 'シューズ',
            color       : '黄',
            brand       : '',
            type        : 'LO',
            point       : 650,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリティーオールフレンズチャンネル',
            id          : 'PT1-115',
            rare        : 'SR',
            name        : 'オールフレンズそらみらぁらヘアアクセ',
            imgUrl      : '/images/items/PT1-115.png',
            kind        : 'ヘアアクセ',
            color       : '桃',
            brand       : '',
            type        : 'LO',
            point       : 650,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリティーオールフレンズチャンネル',
            rare        : 'SR',
          }),


          item({
            collection  : 'プリティーオールフレンズチャンネル',
            id          : 'PT1-116',
            rare        : 'SR',
            name        : 'オールフレンズそらみみれぃワンピ',
            imgUrl      : '/images/items/PT1-116.png',
            kind        : 'ワンピース',
            color       : '緑',
            brand       : '',
            type        : 'PO',
            point       : 1300,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリティーオールフレンズチャンネル',
            id          : 'PT1-117',
            rare        : 'SR',
            name        : 'オールフレンズそらみみれぃシューズ',
            imgUrl      : '/images/items/PT1-117.png',
            kind        : 'シューズ',
            color       : '緑',
            brand       : '',
            type        : 'PO',
            point       : 650,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリティーオールフレンズチャンネル',
            id          : 'PT1-118',
            rare        : 'SR',
            name        : 'オールフレンズそらみみれぃヘアアクセ',
            imgUrl      : '/images/items/PT1-118.png',
            kind        : 'ヘアアクセ',
            color       : '緑',
            brand       : '',
            type        : 'PO',
            point       : 650,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリティーオールフレンズチャンネル',
            rare        : 'SR',
          }),


          item({
            collection  : 'プリティーオールフレンズチャンネル',
            id          : 'PT1-119',
            rare        : 'SR',
            name        : 'オールフレンズそらみそふぃワンピ',
            imgUrl      : '/images/items/PT1-119.png',
            kind        : 'ワンピース',
            color       : '紫',
            brand       : '',
            type        : 'CO',
            point       : 1300,
            numOwned    : { usual: 7 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリティーオールフレンズチャンネル',
            id          : 'PT1-120',
            rare        : 'SR',
            name        : 'オールフレンズそらみそふぃシューズ',
            imgUrl      : '/images/items/PT1-120.png',
            kind        : 'シューズ',
            color       : '赤',
            brand       : '',
            type        : 'CO',
            point       : 650,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリティーオールフレンズチャンネル',
            id          : 'PT1-121',
            rare        : 'SR',
            name        : 'オールフレンズそらみそふぃヘアアクセ',
            imgUrl      : '/images/items/PT1-121.png',
            kind        : 'ヘアアクセ',
            color       : '紫',
            brand       : '',
            type        : 'CO',
            point       : 650,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリティーオールフレンズチャンネル',
            rare        : 'SR',
          }),


          // [NOTE] ニコチケ PR
          // ================================================================================

          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT1-01',
            rare        : 'PR',
            name        : 'シークレットワンダーランドピンクトップス',
            imgUrl      : '/images/items/NC-PT1-01.png',
            kind        : 'トップス',
            color       : '桃',
            brand       : 'SA',
            type        : 'CO',
            point       : 900,
            numOwned    : { nico: 3 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT1-02',
            rare        : 'PR',
            name        : 'シークレットワンダーランドピンクスカート',
            imgUrl      : '/images/items/NC-PT1-02.png',
            kind        : 'ボトムス',
            color       : '桃',
            brand       : 'SA',
            type        : 'CO',
            point       : 800,
            aggregation : 'NC-PT1-01',
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT1-03',
            rare        : 'PR',
            name        : 'シークレットワンダーランドピンクシューズ',
            imgUrl      : '/images/items/NC-PT1-03.png',
            kind        : 'シューズ',
            color       : '桃',
            brand       : 'SA',
            type        : 'CO',
            point       : 850,
            aggregation : 'NC-PT1-01',
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT1-04',
            rare        : 'PR',
            name        : 'シークレットワンダーランドピンクヘアアクセ',
            imgUrl      : '/images/items/NC-PT1-04.png',
            kind        : 'ヘアアクセ',
            color       : '桃',
            brand       : 'SA',
            type        : 'CO',
            point       : 800,
            aggregation : 'NC-PT1-01',
          }),


          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT1-05',
            rare        : 'PR',
            name        : 'ハッピーバルーングリーントップス',
            imgUrl      : '/images/items/NC-PT1-05.png',
            kind        : 'トップス',
            color       : '緑',
            brand       : 'SH',
            type        : 'LO',
            point       : 900,
            numOwned    : { nico: 2 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT1-06',
            rare        : 'PR',
            name        : 'ハッピーバルーングリーンスカート',
            imgUrl      : '/images/items/NC-PT1-06.png',
            kind        : 'ボトムス',
            color       : '緑',
            brand       : 'SH',
            type        : 'LO',
            point       : 800,
            aggregation : 'NC-PT1-05',
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT1-07',
            rare        : 'PR',
            name        : 'ハッピーバルーングリーンシューズ',
            imgUrl      : '/images/items/NC-PT1-07.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : 'SH',
            type        : 'LO',
            point       : 850,
            aggregation : 'NC-PT1-05',
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT1-08',
            rare        : 'PR',
            name        : 'ハッピーバルーングリーンヘアアクセ',
            imgUrl      : '/images/items/NC-PT1-08.png',
            kind        : 'ヘアアクセ',
            color       : '緑',
            brand       : 'SH',
            type        : 'LO',
            point       : 800,
            aggregation : 'NC-PT1-05',
          }),



          // [NOTE] ニコチケ SR
          // ================================================================================

          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT1-09',
            rare        : 'SR',
            name        : 'アーガイルハートパープルワンピ',
            imgUrl      : '/images/items/NC-PT1-09.png',
            kind        : 'ワンピース',
            color       : '紫',
            brand       : 'CH',
            type        : 'LO',
            point       : 1300,
            numOwned    : { nico: 3 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT1-10',
            rare        : 'SR',
            name        : 'アーガイルハートパープルシューズ',
            imgUrl      : '/images/items/NC-PT1-10.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : 'CH',
            type        : 'LO',
            point       : 650,
            aggregation : 'NC-PT1-09',
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT1-11',
            rare        : 'SR',
            name        : 'アーガイルハートパープルヘアアクセ',
            imgUrl      : '/images/items/NC-PT1-11.png',
            kind        : 'ヘアアクセ',
            color       : '紫',
            brand       : 'CH',
            type        : 'LO',
            point       : 650,
            aggregation : 'NC-PT1-09',
          }),
          item({
            collection  : 'ニコチケ',
            rare        : 'SR',
          }),


          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT1-12',
            rare        : 'SR',
            name        : 'ブリティッシュアイドルブラックトップス',
            imgUrl      : '/images/items/NC-PT1-12.png',
            kind        : 'トップス',
            color       : '黒',
            brand       : 'SA',
            type        : 'CO',
            point       : 750,
            numOwned    : { nico: 3 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT1-13',
            rare        : 'SR',
            name        : 'ブリティッシュアイドルブラックスカート',
            imgUrl      : '/images/items/NC-PT1-13.png',
            kind        : 'ボトムス',
            color       : '黒',
            brand       : 'SA',
            type        : 'CO',
            point       : 700,
            aggregation : 'NC-PT1-12',
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT1-14',
            rare        : 'SR',
            name        : 'ブリティッシュアイドルブラックシューズ',
            imgUrl      : '/images/items/NC-PT1-14.png',
            kind        : 'シューズ',
            color       : '黒',
            brand       : 'SA',
            type        : 'CO',
            point       : 650,
            aggregation : 'NC-PT1-12',
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT1-15',
            rare        : 'SR',
            name        : 'ブリティッシュアイドルブラックヘアアクセ',
            imgUrl      : '/images/items/NC-PT1-15.png',
            kind        : 'ヘアアクセ',
            color       : '黒',
            brand       : 'SA',
            type        : 'CO',
            point       : 650,
            aggregation : 'NC-PT1-12',
          }),


          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT1-16',
            rare        : 'SR',
            name        : 'ブリティッシュアイドルレッドトップス',
            imgUrl      : '/images/items/NC-PT1-16.png',
            kind        : 'トップス',
            color       : '赤',
            brand       : 'SA',
            type        : 'CO',
            point       : 750,
            numOwned    : { nico: 4 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT1-17',
            rare        : 'SR',
            name        : 'ブリティッシュアイドルレッドスカート',
            imgUrl      : '/images/items/NC-PT1-17.png',
            kind        : 'ボトムス',
            color       : '赤',
            brand       : 'SA',
            type        : 'CO',
            point       : 700,
            aggregation : 'NC-PT1-16',
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT1-18',
            rare        : 'SR',
            name        : 'ブリティッシュアイドルレッドシューズ',
            imgUrl      : '/images/items/NC-PT1-18.png',
            kind        : 'シューズ',
            color       : '赤',
            brand       : 'SA',
            type        : 'CO',
            point       : 650,
            aggregation : 'NC-PT1-16',
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT1-19',
            rare        : 'SR',
            name        : 'ブリティッシュアイドルレッドヘアアクセ',
            imgUrl      : '/images/items/NC-PT1-19.png',
            kind        : 'ヘアアクセ',
            color       : '赤',
            brand       : 'SA',
            type        : 'CO',
            point       : 650,
            aggregation : 'NC-PT1-16',
          }),


          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT1-20',
            rare        : 'SR',
            name        : 'ブリティッシュアイドルブルートップス',
            imgUrl      : '/images/items/NC-PT1-20.png',
            kind        : 'トップス',
            color       : '青',
            brand       : 'SA',
            type        : 'CO',
            point       : 750,
            numOwned    : { nico: 1 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT1-21',
            rare        : 'SR',
            name        : 'ブリティッシュアイドルブルースカート',
            imgUrl      : '/images/items/NC-PT1-21.png',
            kind        : 'ボトムス',
            color       : '青',
            brand       : 'SA',
            type        : 'CO',
            point       : 700,
            aggregation : 'NC-PT1-20',
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT1-22',
            rare        : 'SR',
            name        : 'ブリティッシュアイドルブルーシューズ',
            imgUrl      : '/images/items/NC-PT1-22.png',
            kind        : 'シューズ',
            color       : '青',
            brand       : 'SA',
            type        : 'CO',
            point       : 650,
            aggregation : 'NC-PT1-20',
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT1-23',
            rare        : 'SR',
            name        : 'ブリティッシュアイドルブルーヘアアクセ',
            imgUrl      : '/images/items/NC-PT1-23.png',
            kind        : 'ヘアアクセ',
            color       : '青',
            brand       : 'SA',
            type        : 'CO',
            point       : 650,
            aggregation : 'NC-PT1-20',
          }),


          // [NOTE] ニコチケ R
          // ================================================================================

          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT1-24',
            rare        : 'R',
            name        : 'そらセーラーむらさきトップス',
            imgUrl      : '/images/items/NC-PT1-24.png',
            kind        : 'トップス',
            color       : '紫',
            brand       : '',
            type        : 'LO',
            point       : 600,
            numOwned    : { nico: 2 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT1-25',
            rare        : 'R',
            name        : 'そらセーラーむらさきスカート',
            imgUrl      : '/images/items/NC-PT1-25.png',
            kind        : 'ボトムス',
            color       : '紫',
            brand       : '',
            type        : 'LO',
            point       : 550,
            aggregation : 'NC-PT1-24',
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT1-26',
            rare        : 'R',
            name        : 'そらセーラーむらさきシューズ',
            imgUrl      : '/images/items/NC-PT1-26.png',
            kind        : 'シューズ',
            color       : '紫',
            brand       : '',
            type        : 'LO',
            point       : 500,
            aggregation : 'NC-PT1-24',
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT1-27',
            rare        : 'R',
            name        : 'そらセーラーむらさきヘアアクセ',
            imgUrl      : '/images/items/NC-PT1-27.png',
            kind        : 'ヘアアクセ',
            color       : '紫',
            brand       : '',
            type        : 'LO',
            point       : 500,
            aggregation : 'NC-PT1-24',
          }),


          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT1-28',
            rare        : 'R',
            name        : 'そらクッキングむらさきトップス',
            imgUrl      : '/images/items/NC-PT1-28.png',
            kind        : 'トップス',
            color       : '紫',
            brand       : 'GY',
            type        : 'PO',
            point       : 600,
            numOwned    : { nico: 3 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT1-29',
            rare        : 'R',
            name        : 'そらクッキングむらさきスカート',
            imgUrl      : '/images/items/NC-PT1-29.png',
            kind        : 'ボトムス',
            color       : '紫',
            brand       : 'GY',
            type        : 'PO',
            point       : 550,
            aggregation : 'NC-PT1-28',
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT1-30',
            rare        : 'R',
            name        : 'そらクッキングむらさきシューズ',
            imgUrl      : '/images/items/NC-PT1-30.png',
            kind        : 'シューズ',
            color       : '紫',
            brand       : 'GY',
            type        : 'PO',
            point       : 500,
            aggregation : 'NC-PT1-28',
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT1-31',
            rare        : 'R',
            name        : 'そらクッキングむらさきヘアアクセ',
            imgUrl      : '/images/items/NC-PT1-31.png',
            kind        : 'ヘアアクセ',
            color       : '紫',
            brand       : 'GY',
            type        : 'PO',
            point       : 500,
            aggregation : 'NC-PT1-28',
          }),


          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT1-32',
            rare        : 'R',
            name        : 'そらクッキングももいろトップス',
            imgUrl      : '/images/items/NC-PT1-32.png',
            kind        : 'トップス',
            color       : '桃',
            brand       : 'GY',
            type        : 'PO',
            point       : 600,
            numOwned    : { nico: 2 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT1-33',
            rare        : 'R',
            name        : 'そらクッキングももいろスカート',
            imgUrl      : '/images/items/NC-PT1-33.png',
            kind        : 'ボトムス',
            color       : '桃',
            brand       : 'GY',
            type        : 'PO',
            point       : 550,
            aggregation : 'NC-PT1-32',
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT1-34',
            rare        : 'R',
            name        : 'そらクッキングももいろシューズ',
            imgUrl      : '/images/items/NC-PT1-34.png',
            kind        : 'シューズ',
            color       : '桃',
            brand       : 'GY',
            type        : 'PO',
            point       : 500,
            aggregation : 'NC-PT1-32',
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT1-35',
            rare        : 'R',
            name        : 'そらクッキングももいろヘアアクセ',
            imgUrl      : '/images/items/NC-PT1-35.png',
            kind        : 'ヘアアクセ',
            color       : '桃',
            brand       : 'GY',
            type        : 'PO',
            point       : 500,
            aggregation : 'NC-PT1-32',
          }),


          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT1-36',
            rare        : 'R',
            name        : 'そらクッキングみずいろトップス',
            imgUrl      : '/images/items/NC-PT1-36.png',
            kind        : 'トップス',
            color       : '水',
            brand       : 'GY',
            type        : 'PO',
            point       : 600,
            numOwned    : { nico: 4 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT1-37',
            rare        : 'R',
            name        : 'そらクッキングみずいろスカート',
            imgUrl      : '/images/items/NC-PT1-37.png',
            kind        : 'ボトムス',
            color       : '水',
            brand       : 'GY',
            type        : 'PO',
            point       : 550,
            aggregation : 'NC-PT1-36',
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT1-38',
            rare        : 'R',
            name        : 'そらクッキングみずいろシューズ',
            imgUrl      : '/images/items/NC-PT1-38.png',
            kind        : 'シューズ',
            color       : '水',
            brand       : 'GY',
            type        : 'PO',
            point       : 500,
            aggregation : 'NC-PT1-36',
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT1-39',
            rare        : 'R',
            name        : 'そらクッキングみずいろヘアアクセ',
            imgUrl      : '/images/items/NC-PT1-39.png',
            kind        : 'ヘアアクセ',
            color       : '水',
            brand       : 'GY',
            type        : 'PO',
            point       : 500,
            aggregation : 'NC-PT1-36',
          }),


          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT1-40',
            rare        : 'R',
            name        : 'ダイヤチェックスウィートトップス',
            imgUrl      : '/images/items/NC-PT1-40.png',
            kind        : 'トップス',
            color       : '桃',
            brand       : '',
            type        : 'LO',
            point       : 600,
            numOwned    : { nico: 3 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT1-41',
            rare        : 'R',
            name        : 'ダイヤチェックスウィートスカート',
            imgUrl      : '/images/items/NC-PT1-41.png',
            kind        : 'ボトムス',
            color       : '桃',
            brand       : '',
            type        : 'LO',
            point       : 550,
            aggregation : 'NC-PT1-40',
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT1-42',
            rare        : 'R',
            name        : 'ダイヤチェックスウィートシューズ',
            imgUrl      : '/images/items/NC-PT1-42.png',
            kind        : 'シューズ',
            color       : '桃',
            brand       : '',
            type        : 'LO',
            point       : 500,
            aggregation : 'NC-PT1-40',
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT1-43',
            rare        : 'R',
            name        : 'ダイヤチェックスウィートヘアアクセ',
            imgUrl      : '/images/items/NC-PT1-43.png',
            kind        : 'ヘアアクセ',
            color       : '桃',
            brand       : '',
            type        : 'LO',
            point       : 500,
            aggregation : 'NC-PT1-40',
          }),


          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT1-44',
            rare        : 'R',
            name        : 'ダイヤチェックガールビビッドトップス',
            imgUrl      : '/images/items/NC-PT1-44.png',
            kind        : 'トップス',
            color       : '水',
            brand       : 'GY',
            type        : 'PO',
            point       : 600,
            numOwned    : { nico: 1 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT1-45',
            rare        : 'R',
            name        : 'ダイヤチェックガールビビッドスカート',
            imgUrl      : '/images/items/NC-PT1-45.png',
            kind        : 'ボトムス',
            color       : '水',
            brand       : 'GY',
            type        : 'PO',
            point       : 550,
            aggregation : 'NC-PT1-44',
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT1-46',
            rare        : 'R',
            name        : 'ダイヤチェックガールビビッドシューズ',
            imgUrl      : '/images/items/NC-PT1-46.png',
            kind        : 'シューズ',
            color       : '水',
            brand       : 'GY',
            type        : 'PO',
            point       : 500,
            aggregation : 'NC-PT1-44',
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT1-47',
            rare        : 'R',
            name        : 'ダイヤチェックガールビビッドヘアアクセ',
            imgUrl      : '/images/items/NC-PT1-47.png',
            kind        : 'ヘアアクセ',
            color       : '水',
            brand       : 'GY',
            type        : 'PO',
            point       : 500,
            aggregation : 'NC-PT1-44',
          }),


          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT1-48',
            rare        : 'R',
            name        : 'ダイヤチェックガールスウィートトップス',
            imgUrl      : '/images/items/NC-PT1-48.png',
            kind        : 'トップス',
            color       : '桃',
            brand       : 'GY',
            type        : 'PO',
            point       : 600,
            numOwned    : { nico: 3 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT1-49',
            rare        : 'R',
            name        : 'ダイヤチェックガールスウィートスカート',
            imgUrl      : '/images/items/NC-PT1-49.png',
            kind        : 'ボトムス',
            color       : '桃',
            brand       : 'GY',
            type        : 'PO',
            point       : 550,
            aggregation : 'NC-PT1-48',
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT1-50',
            rare        : 'R',
            name        : 'ダイヤチェックガールスウィートシューズ',
            imgUrl      : '/images/items/NC-PT1-50.png',
            kind        : 'シューズ',
            color       : '桃',
            brand       : 'GY',
            type        : 'PO',
            point       : 500,
            aggregation : 'NC-PT1-48',
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT1-51',
            rare        : 'R',
            name        : 'ダイヤチェックガールスウィートヘアアクセ',
            imgUrl      : '/images/items/NC-PT1-51.png',
            kind        : 'ヘアアクセ',
            color       : '桃',
            brand       : 'GY',
            type        : 'PO',
            point       : 500,
            aggregation : 'NC-PT1-48',
          }),


          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT1-52',
            rare        : 'R',
            name        : 'ダイヤチェックガールローズトップス',
            imgUrl      : '/images/items/NC-PT1-52.png',
            kind        : 'トップス',
            color       : '赤',
            brand       : 'GY',
            type        : 'PO',
            point       : 600,
            numOwned    : { nico: 3 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT1-53',
            rare        : 'R',
            name        : 'ダイヤチェックガールローズスカート',
            imgUrl      : '/images/items/NC-PT1-53.png',
            kind        : 'ボトムス',
            color       : '赤',
            brand       : 'GY',
            type        : 'PO',
            point       : 550,
            aggregation : 'NC-PT1-52',
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT1-54',
            rare        : 'R',
            name        : 'ダイヤチェックガールローズシューズ',
            imgUrl      : '/images/items/NC-PT1-54.png',
            kind        : 'シューズ',
            color       : '赤',
            brand       : 'GY',
            type        : 'PO',
            point       : 500,
            aggregation : 'NC-PT1-52',
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT1-55',
            rare        : 'R',
            name        : 'ダイヤチェックガールローズヘアアクセ',
            imgUrl      : '/images/items/NC-PT1-55.png',
            kind        : 'ヘアアクセ',
            color       : '赤',
            brand       : 'GY',
            type        : 'PO',
            point       : 500,
            aggregation : 'NC-PT1-52',
          }),


          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT1-56',
            rare        : 'R',
            name        : 'プリ☆チャンランドキャストイエロートップス',
            imgUrl      : '/images/items/NC-PT1-56.png',
            kind        : 'トップス',
            color       : '黄',
            brand       : 'LP',
            type        : 'PO',
            point       : 600,
            numOwned    : { nico: 3 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT1-57',
            rare        : 'R',
            name        : 'プリ☆チャンランドキャストイエロースカート',
            imgUrl      : '/images/items/NC-PT1-57.png',
            kind        : 'ボトムス',
            color       : '黄',
            brand       : 'LP',
            type        : 'PO',
            point       : 550,
            aggregation : 'NC-PT1-56',
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT1-58',
            rare        : 'R',
            name        : 'プリ☆チャンランドキャストイエローシューズ',
            imgUrl      : '/images/items/NC-PT1-58.png',
            kind        : 'シューズ',
            color       : '黄',
            brand       : 'LP',
            type        : 'PO',
            point       : 500,
            aggregation : 'NC-PT1-56',
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT1-59',
            rare        : 'R',
            name        : 'プリ☆チャンランドキャストイエローヘアアクセ',
            imgUrl      : '/images/items/NC-PT1-59.png',
            kind        : 'ヘアアクセ',
            color       : '黄',
            brand       : 'LP',
            type        : 'PO',
            point       : 500,
            aggregation : 'NC-PT1-56',
          }),


          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT1-60',
            rare        : 'R',
            name        : 'プリ☆チャンランドキャストブルートップス',
            imgUrl      : '/images/items/NC-PT1-60.png',
            kind        : 'トップス',
            color       : '青',
            brand       : 'LP',
            type        : 'CO',
            point       : 600,
            numOwned    : { nico: 2 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT1-61',
            rare        : 'R',
            name        : 'プリ☆チャンランドキャストブルースカート',
            imgUrl      : '/images/items/NC-PT1-61.png',
            kind        : 'ボトムス',
            color       : '青',
            brand       : 'LP',
            type        : 'CO',
            point       : 550,
            aggregation : 'NC-PT1-60',
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT1-62',
            rare        : 'R',
            name        : 'プリ☆チャンランドキャストブルーシューズ',
            imgUrl      : '/images/items/NC-PT1-62.png',
            kind        : 'シューズ',
            color       : '青',
            brand       : 'LP',
            type        : 'CO',
            point       : 500,
            aggregation : 'NC-PT1-60',
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT1-63',
            rare        : 'R',
            name        : 'プリ☆チャンランドキャストブルーヘアアクセ',
            imgUrl      : '/images/items/NC-PT1-63.png',
            kind        : 'ヘアアクセ',
            color       : '青',
            brand       : 'LP',
            type        : 'CO',
            point       : 500,
            aggregation : 'NC-PT1-60',
          }),


          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT1-64',
            rare        : 'R',
            name        : 'がおがおふぁいが～ホワイトトップス',
            imgUrl      : '/images/items/NC-PT1-64.png',
            kind        : 'トップス',
            color       : '白',
            brand       : 'UQ',
            type        : 'CO',
            point       : 600,
            numOwned    : { nico: 4 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT1-65',
            rare        : 'R',
            name        : 'がおがおふぁいが～ホワイトパンツ',
            imgUrl      : '/images/items/NC-PT1-65.png',
            kind        : '  ',
            color       : '白',
            brand       : 'UQ',
            type        : 'CO',
            point       : 550,
            aggregation : 'NC-PT1-64',
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT1-66',
            rare        : 'R',
            name        : 'がおがおふぁいが～ホワイトシューズ',
            imgUrl      : '/images/items/NC-PT1-66.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : 'UQ',
            type        : 'CO',
            point       : 500,
            aggregation : 'NC-PT1-64',
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT1-67',
            rare        : 'R',
            name        : 'がおがおふぁいが～ホワイトヘアアクセ',
            imgUrl      : '/images/items/NC-PT1-67.png',
            kind        : 'ヘアアクセ',
            color       : '黒',
            brand       : 'UQ',
            type        : 'CO',
            point       : 500,
            aggregation : 'NC-PT1-64',
          }),


          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT1-68',
            rare        : 'R',
            name        : 'ペイントパターンイエロートップス',
            imgUrl      : '/images/items/NC-PT1-68.png',
            kind        : 'トップス',
            color       : '黄',
            brand       : 'RB',
            type        : 'CO',
            point       : 600,
            numOwned    : { nico: 4 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT1-69',
            rare        : 'R',
            name        : 'ペイントパターンイエロースカート',
            imgUrl      : '/images/items/NC-PT1-69.png',
            kind        : 'ボトムス',
            color       : '黄',
            brand       : 'RB',
            type        : 'CO',
            point       : 550,
            aggregation : 'NC-PT1-68',
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT1-70',
            rare        : 'R',
            name        : 'ペイントパターンイエローシューズ',
            imgUrl      : '/images/items/NC-PT1-70.png',
            kind        : 'シューズ',
            color       : '黒',
            brand       : 'RB',
            type        : 'CO',
            point       : 500,
            aggregation : 'NC-PT1-68',
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT1-71',
            rare        : 'R',
            name        : 'ペイントパターンイエローヘアアクセ',
            imgUrl      : '/images/items/NC-PT1-71.png',
            kind        : 'ヘアアクセ',
            color       : '黄',
            brand       : 'RB',
            type        : 'CO',
            point       : 500,
            aggregation : 'NC-PT1-68',
          }),


          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT1-72',
            rare        : 'R',
            name        : 'アイスクリームオレンジワンピ',
            imgUrl      : '/images/items/NC-PT1-72.png',
            kind        : 'ワンピース',
            color       : '橙',
            brand       : 'SH',
            type        : 'LO',
            point       : 1000,
            numOwned    : { nico: 3 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT1-73',
            rare        : 'R',
            name        : 'アイスクリームオレンジシューズ',
            imgUrl      : '/images/items/NC-PT1-73.png',
            kind        : 'シューズ',
            color       : '橙',
            brand       : 'SH',
            type        : 'LO',
            point       : 500,
            aggregation : 'NC-PT1-72',
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT1-74',
            rare        : 'R',
            name        : 'アイスクリームオレンジヘアアクセ',
            imgUrl      : '/images/items/NC-PT1-74.png',
            kind        : 'ヘアアクセ',
            color       : '橙',
            brand       : 'SH',
            type        : 'LO',
            point       : 500,
            aggregation : 'NC-PT1-72',
          }),
          item({
            collection  : 'ニコチケ',
            rare        : 'R',
          }),


          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT1-75',
            rare        : 'R',
            name        : 'ドレッシーストライプグリーントップス',
            imgUrl      : '/images/items/NC-PT1-75.png',
            kind        : 'トップス',
            color       : '緑',
            brand       : 'PM',
            type        : 'PR',
            point       : 600,
            numOwned    : { nico: 4 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT1-76',
            rare        : 'R',
            name        : 'ドレッシーストライプグリーンスカート',
            imgUrl      : '/images/items/NC-PT1-76.png',
            kind        : 'ボトムス',
            color       : '緑',
            brand       : 'PM',
            type        : 'PR',
            point       : 550,
            aggregation : 'NC-PT1-75',
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT1-77',
            rare        : 'R',
            name        : 'ドレッシーストライプグリーンシューズ',
            imgUrl      : '/images/items/NC-PT1-77.png',
            kind        : 'シューズ',
            color       : '緑',
            brand       : 'PM',
            type        : 'PR',
            point       : 500,
            aggregation : 'NC-PT1-75',
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT1-78',
            rare        : 'R',
            name        : 'ドレッシーストライプグリーンヘアアクセ',
            imgUrl      : '/images/items/NC-PT1-78.png',
            kind        : 'ヘアアクセ',
            color       : '緑',
            brand       : 'PM',
            type        : 'PR',
            point       : 500,
            aggregation : 'NC-PT1-75',
          }),


        ]
      }
    },

    computed: {
      itemsFiltered () {
        const { excepts, items } = this
        return excepts.length
          ? items.filter(item => !excepts.includes(item.collection) )
          : items
      },

      itemsMaJor () {
        const { major, itemsFiltered, itemsPasha } = this
        return itemsFiltered.filter(item => major.includes(item.collection) && !itemsPasha.includes(item))
      },

      itemsIR () {
        return _.where(this.itemsMaJor, { rare: 'IR' })
      },

      itemsWR () {
        return _.where(this.itemsMaJor, { rare: 'WR' })
      },

      itemsER () {
        return _.where(this.itemsMaJor, { rare: 'ER' })
      },

      itemsFR () {
        return _.where(this.itemsMaJor, { rare: 'FR' })
      },

      itemsPR () {
        return _.where(this.itemsMaJor, { rare: 'PR' })
      },

      itemsSR () {
        return _.where(this.itemsMaJor, { rare: 'SR' })
      },

      itemsR () {
        return _.where(this.itemsMaJor, { rare: 'R' })
      },

      itemsN () {
        return _.where(this.itemsMaJor, { rare: 'N' })
      },

      itemsPasha () {
        return _.where(this.itemsFiltered, { kind: 'パシャッとアイテム' }).filter(item => this.major.includes(item.collection) )
      },

      itemsCoordePritamaTicket () {
        return _.where(this.itemsFiltered, { collection: 'コーデプリたまチケット' })
      },
      itemsPBox () {
        return _.where(this.itemsFiltered, { collection: 'プレゼントボックス' })
      },

      itemsMolly () {
        return _.where(this.itemsFiltered, { collection: 'モーリーファンタジー限定' })
      },

      itemsEaster () {
        return _.where(this.itemsFiltered, { collection: 'イースターチャンネル' })
      },

      itemsAllFriends () {
        return _.where(this.itemsFiltered, { collection: 'プリティーオールフレンズチャンネル' })
      },

      itemsNico () {
        return _.where(this.itemsFiltered, { collection: 'ニコチケ' })
      },

      itemsNicoPR () {
        return _.where(this.itemsNico, { rare: 'PR' })
      },

      itemsNicoSR () {
        return _.where(this.itemsNico, { rare: 'SR' })
      },

      itemsNicoR () {
        return _.where(this.itemsNico, { rare: 'R' })
      },

      itemsNicoN () {
        return _.where(this.itemsNico, { rare: 'N' })
      },
    },
  }
</script>


<template>
  <ItemPage :items="items" :narrowCols="[1]">

    <template #title>
      <PageChooser />
      <time>{{ date }}</time>
    </template>

    <template #col1>
      <ItemList title="✨ IR ✨" color="#edd50f" :items="itemsIR" />
      <ItemList title="🥚 ER 🥚" color="#44cd1f" :items="itemsER" />
    </template>

    <template #col2>
      <ItemList title="⭐️ WR ⭐️" color="#ffca59" :items="itemsWR" />
      <ItemList title="👑 FR 👑" color="#ff5d91" :items="itemsFR" />
      <ItemList title="PR ★★★" color="#ffa1bc" :items="itemsPR" />
    </template>

    <template #col3>
      <ItemList title="SR ★★" color="#00c7da" :items="itemsSR" />
      <ItemList title="モーリー限定 SR ★★" color="#55b272" :items="itemsMolly" />
      <ItemList title="コーデプリたまチケット|SR ★★" color="#00c7da" :items="itemsCoordePritamaTicket" />
    </template>

    <template #col4>
      <ItemList title="R ★" color="#feab0d" :items="itemsR" />
    </template>

    <template #col5>
      <ItemList title="N" color="#f6c3b2" :items="itemsN" />
      <ItemList title="パシャッとアイテム" color="#c598ff" :items="itemsPasha" />
      <ItemList title="プレゼントボックス" color="#c598ff" :items="itemsPBox" />
    </template>

    <template #col6>
      <ItemList title="イースターチャンネル" color="#a1c0fa" :items="itemsEaster" />
      <ItemList title="プリティーオールフレンズ|チャンネル" color="#a1c0fa" :items="itemsAllFriends" />
    </template>

    <template #col7>
      <ItemList title="ニコチケ PR ★★★" color="#ffa1bc" :items="itemsNicoPR" />
      <ItemList title="ニコチケ SR ★★" color="#00c7da" :items="itemsNicoSR" />
    </template>

    <template #col8>
      <ItemList title="ニコチケ R ★" color="#feab0d" :items="itemsNicoR | first(7 * 4)" />
    </template>

    <template #col9>
      <ItemList title="ニコチケ R ★" color="#feab0d" :items="itemsNicoR | rest(7 * 4)" :isOrphan="true" />
      <Status :date="date" :items="items" :showKira="true" :showNico="true" />
    </template>

  </ItemPage>
</template>


<style lang="scss" scoped>
  @import '~@/stylesheets/common';

  // PC View: ステータスの表示位置を調整
  .Page ::v-deep .Status {
    // PC View のとき position: absolute になっている (see: ItemPage.vue)
    bottom: 0;
    // right: 0;
  }

  // PC View: ステータス表示を置く空間を確保
  // @include iroha-vw-range($from: strip-unit($device-width--pc), $also-apply: print) {
  //   .Page ::v-deep .Page__body {
  //     padding-bottom: $size-unit * 20;
  //   }
  // }
</style>
